export default __webpack_public_path__ + "static/media/spinner.4628ba16.gif";